import { AccountAvatarView } from "./components/AccountAvatarView";
import { getAccountAvatarSrc } from "./helpers/getAccountAvatarSrc";
import { getAccountInitial } from "./helpers/getAccountInitial";

export { EditableAccountAvatar } from "./components/EditableAccountAvatar";

type AccountAvatarProps = {
  account?: {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    imageUrl?: string | null;
    avatar?: string | null;
  } | null;
  size?: number;
};

export const AccountAvatar = ({ account, size = 48 }: AccountAvatarProps) => {
  const src = getAccountAvatarSrc(account);
  const initial = getAccountInitial(account);
  const alt = [account?.firstName, account?.lastName].filter(Boolean).join(" ") || account?.email || "Account";

  return <AccountAvatarView src={src} initial={initial} size={size} alt={alt} />;
};
